import { render, staticRenderFns } from "./CompanySnapshot.vue?vue&type=template&id=298ef98c&"
import script from "./CompanySnapshot.vue?vue&type=script&lang=js&"
export * from "./CompanySnapshot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports